import { BadgeCheck } from "lucide-react";
import { Container } from "@/components/atoms";

// Trust Verification Strip — 99.5% accuracy badge + lab credibility (frame 60:2).
export function TrustVerification() {
  return (
    <section className="bg-leaf-green/10 py-12">
      <Container className="flex flex-col items-center gap-6 text-center md:flex-row md:justify-center md:gap-12 md:text-left">
        <div className="flex items-center gap-4">
          <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-full bg-leaf-green-ink text-white">
            <span className="font-condensed text-xl font-bold leading-none">
              99.5%
            </span>
            <span className="text-[9px] uppercase tracking-wide">accuracy</span>
          </div>
          <div className="max-w-sm">
            <h3 className="font-condensed text-xl font-bold text-night-blue">
              Verified by CBD Informative
            </h3>
            <p className="text-sm text-night-blue/70">
              Every batch is independently tested for potency and purity. What’s
              on the label is what’s in the bottle.
            </p>
          </div>
        </div>
        <ul className="grid gap-2 text-left text-sm text-night-blue/80">
          {[
            "Third-party lab tested",
            "Full Certificate of Analysis",
            "ZERO THC",
            "Made in the USA",
          ].map((x) => (
            <li key={x} className="flex items-center gap-2">
              <BadgeCheck size={16} className="text-leaf-green-ink" /> {x}
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
